import { component } from 'picoapp'
import { zelektor, loopify, renderProductCard, toggleDisplay } from '@/lib/utility-functions.js'
import filter from '@/lib/collection-filter.js'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { id, pageSize, handle, collectionSize } = node.dataset

    const {
        filter: filterEl,
        filterBar,
        toggles,
        sorting,
        output,
        paginationContainer,
        pagination,
        filterCloseBtn,
        toggleFilterBtn: toggleFilterBtns,
        filterGroup: filterGroups,
        colorSwatch: colorSwatches,
        paginationText,
        paginationProgress,
        clearBtn
    } = zelektor(node)

    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    ctx.on('filter:loaded', ({ filter }) => {
        ctx.emit('filter:togglesRendered')
    })
    ctx.on('filter:query', updateToggles)
    ctx.on('filter:togglesRendered', ({filter}) => {
        filterEl.classList.add('filter-ready');
        updateSizeFilter(filter)
        initClearBtn(filter)
    })
    ctx.on('filter:render', ({filter}) => {
        showPagination()
        updatePagination(filter)
    })
    
    filterEl.addEventListener('click', e => {
        if (e.target === filterEl) closeFilter()
    })

    filterCloseBtn.addEventListener('click', closeFilter)

    toggleFilterBtns.forEach(btn => {
        btn.addEventListener('click', toggleFilterGroup)
    })


    /*******************************************************************************************************************************************/
    /* Init
    /*******************************************************************************************************************************************/

    // Check if gender neutral collection
    let isNeutralCollection = false;
    if (window.location.pathname.indexOf('maend') === -1 && window.location.pathname.indexOf('kvinder') === -1) {
        let isNeutralCollection = true;
    }

    filter(node, {
        id,
        handle,
        collectionSize,
        limit: 150,
        sorting,
        output,
        paginate: parseInt(pageSize),
        pagination: {
            element: pagination,
            type: 'button'
        },
        activeClass: 'is-active',
        toggles,
        render: {
            brands: val => renderBrand(val),
            color: val => renderColor(val),
            size: val => renderSize(val),
            type: val => renderType(val),
            gender: val => renderGender(val)
        },
        renderItem: renderProductCard,
        colorSwatches: getColorSwatches()
    })
    // Render in toggles before products are loaded.
    renderToggles(ctx.getState().filter);
    // Add eventlistener to toggles, so the sidebar can be activated before products are loaded.
    initToggles(ctx.getState().filter);

    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function renderBrand(val) {
        const brand = window.theme.brands.find(b => b.vendor_name === val)
        const logoUrl = brand ? brand.logo_dark : undefined

        return  `
                <li class="filter-item" data-filter-item data-value="${val}">
                    ${logoUrl ? `<img src="${logoUrl}">` : `<span>${val}</span>`}
                    <div class="filter-item__checkmark">${window.theme.templates.checkmark}</div>
                </li>
                `
    }

    function renderColor(val) {
        const swatch = ctx.getState().filter.config.colorSwatches.find(sw => sw.name === val)
        const swatchUrl = swatch ? swatch.image : undefined

        if (val) return `
                        <li class="filter-item" data-filter-item data-value="${val}">
                            <div class="filter-item__swatch">
                                ${swatchUrl ? `<img src="${swatchUrl}">` : ''}
                                <div class="filter-item__swatch__checkmark">${window.theme.templates.checkmark}</div>
                            </div>
                            <span>${val}</span>
                        </li>
                        `
    }

    function renderSize(val) {
        return `<li class="filter-item" data-filter-item data-value=${val.includes(`"`) ? `'` : `"`}${val}${val.includes(`"`) ? `'` : `"`}>${val}</li>`
    }

    function renderType(val) {
        if (val) return  `
                <li class="filter-item" data-filter-item data-value="${val}">
                    <span class="filter-item__value">${val}</span>
                    <div class="filter-item__checkmark">${window.theme.templates.checkmark}</div>
                </li>
                `
    }

    function renderGender(val) {
        if (isNeutralCollection) {
            return;
        } else if (val) {
            return  `
                <li class="filter-item" data-filter-item data-value="${val}">
                    <span class="filter-item__value">${val}</span>
                    <div class="filter-item__checkmark">${window.theme.templates.checkmark}</div>
                </li>
                `
        }
    }

    function renderToggles(filter) {
        const { filters } = filter
        const { toggles: toggleContainer } = filter.config

        filters.forEach(f => {
            const toggleItem = document.createElement('li')
            toggleContainer.appendChild(toggleItem)
            toggleItem.outerHTML =  `
                                    <li class="collection__main__filter__toggle-item collection__main__filter__toggle-item--desktop js-toggleItem${f.name === 'size' ? ' js-sizeFilterEl' : ''}" data-name="${f.name}">
                                        <span class="collection__main__filter__toggle-item__count js-count"></span>
                                        <span>${f.title}</span>
                                        ${window.theme.templates.downArrow}
                                    </li>
                                    `
        })

        filterBar.classList.add('is-initialized')
    }

    function initToggles(filter) {
        const { toggles: toggleContainer = [] } = filter.config
        const { toggleItem: toggleItems = [] } = zelektor(toggleContainer)

        toggleItems.forEach(item => {
            item.addEventListener('click', openFilter)
        })
    }

    function updateToggles(state, queries) {
        const activeFilters = queries.filter(q => q.activeItems.length)

        const priceQuery = queries.find(q => q.type === 'price')
        if (priceQuery) {
            const min = parseInt(ctx.getState().filter.prices.min)
            const max = parseInt(ctx.getState().filter.prices.max)
            const queryMin = parseInt(priceQuery.params[0])
            const queryMax = parseInt(priceQuery.params[1])

            if (queryMin != min || queryMax != max) {
                if (queryMin != min) priceQuery.activeItems.push('min')
                if (queryMax != max) priceQuery.activeItems.push('max')
                activeFilters.push(priceQuery)
            }
        }

        const { toggles: toggleContainer = [] } = state.filter.config
        const { toggleItem: toggleItems = [] } = zelektor(toggleContainer)

        if(!toggleItems) return ctx.on('filter:togglesRendered', state => updateToggles(state, queries))

        loopify(toggleItems).forEach(item => item.classList.remove('is-active'))

        activeFilters.forEach(f => {
            const { name } = f
            const toggleItem = loopify(toggleItems).find(item => item.dataset.name === name)
            if(!toggleItem) return ctx.on('filter:togglesRendered', state => updateToggles(state, queries))
            const { count } = zelektor(toggleItem)
            toggleItem.classList.add('is-active')
            count.innerText = f.activeItems.length
        })

        activeFilters.length ? clearBtn.classList.add('is-visible') : clearBtn.classList.remove('is-visible')
    }

    function initClearBtn(filter) {
        clearBtn.addEventListener('click', ()=> {
            const items = node.querySelectorAll(filter.config.selectors.filterItem)
            items.forEach(i => i.classList.remove(filter.config.selectors.activeClass))
            ctx.emit('filter:clear')
            ctx.emit('filter:start')
        })
    }

    function getColorSwatches() {
        return loopify(colorSwatches).map(swatch => {
            return {
                name: swatch.dataset.name,
                image: swatch.value
            }
        })
    }

    function showPagination() {
        paginationContainer.classList.add('is-initialized')
    }

    function updatePagination(filter) {
        const { showing, limit } = filter.pagination
        paginationText.innerHTML = window.theme.strings.collection.pagination.replace('%count%',showing).replace('%total%',limit)

        const percentage = showing / limit * 100
        paginationProgress.style.width = `${percentage ? percentage : 0}%`
    }

    function openFilter(e) {
        const thisToggle = e.currentTarget
        const { name } = thisToggle.dataset
        const toggleBtn = name ? loopify(toggleFilterBtns).find(btn => btn.dataset.name === name) : undefined

        loopify(toggleFilterBtns).forEach(btn => btn.classList.remove('is-open'))
        filterGroups.forEach(g => g.style.display = 'none')

        filterEl.classList.add('is-open')
        if (toggleBtn) toggleBtn.click()
    }

    function closeFilter() {
        filterEl.classList.remove('is-open')
    }

    function toggleFilterGroup(e) {
        const thisBtn = e.currentTarget
        const { name } = thisBtn.dataset
        const group = [...filterGroups].find(g => g.dataset.name === name)

        thisBtn.classList.toggle('is-open')
        toggleDisplay(group)
    }

    // If more than one size type in collection, hide the size filter
    function updateSizeFilter(filter) {
        const { sizeFilterEl: sizeFilterElements } = zelektor(node)

        const { products } = filter
        const tags = [...new Set(products.map(p => p.tags.split(', ')).flat())]
        const sizeTags = [...new Set(tags.filter(t => t.includes('sizetype_')))]

        if (sizeTags.length > 1)
            loopify(sizeFilterElements).forEach(el => el.classList.add('is-hidden'))
    }
})